import React from 'react';
import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';

export function StatusBadge({ status, className }) {
  const statusStyles = {
    OPEN: 'status-open',
    DECLARED: 'status-declared',
    ACTIVE: 'status-open',
    INACTIVE: 'bg-muted text-muted-foreground',
    PAYMENT: 'bg-red-500/10 text-red-500 border-red-500/20',
    RECEIPT: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
    BUY: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
    SELL: 'bg-red-500/10 text-red-500 border-red-500/20',
    BACK: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    LAY: 'bg-pink-500/10 text-pink-500 border-pink-500/20',
    YES: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
    NO: 'bg-red-500/10 text-red-500 border-red-500/20'
  };

  return (
    <Badge 
      variant="outline" 
      className={cn(
        "text-xs font-medium uppercase tracking-wider",
        statusStyles[status] || 'bg-muted',
        className
      )}
    >
      {status}
    </Badge>
  );
}
